'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _moment = require('@alicd/next/lib/moment');

var _moment2 = _interopRequireDefault(_moment);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _calendarMixin = require('../calendar-mixin');

var _calendarMixin2 = _interopRequireDefault(_calendarMixin);

var _validators = require('../../utils/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarHead = function (_Component) {
    (0, _inherits3.default)(CalendarHead, _Component);

    function CalendarHead() {
        (0, _classCallCheck3.default)(this, CalendarHead);
        return (0, _possibleConstructorReturn3.default)(this, (CalendarHead.__proto__ || (0, _getPrototypeOf2.default)(CalendarHead)).apply(this, arguments));
    }

    (0, _createClass3.default)(CalendarHead, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefix = _props.prefix,
                type = _props.type,
                locale = _props.locale,
                language = _props.language;

            // 设置多语言

            _moment2.default.locale(language);

            // 获得多语言数据
            var elements = [],
                localeData = _moment2.default.localeData(),
                weekdaysMin = localeData.weekdaysMin(),
                firstDayOfWeek = localeData.firstDayOfWeek();

            if (locale.format) {
                var _ref = locale.format || {},
                    veryShortWeekdays = _ref.veryShortWeekdays,
                    customFirstDayOfWeek = _ref.firstDayOfWeek;

                if (veryShortWeekdays) {
                    weekdaysMin = veryShortWeekdays;
                }
                if ((0, _validators.isWeekdayIndex)(customFirstDayOfWeek)) {
                    firstDayOfWeek = customFirstDayOfWeek;
                }
            }

            for (var i = 0; i < weekdaysMin.length; i++) {
                elements.push(_react2.default.createElement(
                    'th',
                    { key: i,
                        className: prefix + 'calendar-th' },
                    _react2.default.createElement(
                        'span',
                        { className: prefix + 'calendar-th-inner' },
                        weekdaysMin[(i + firstDayOfWeek) % 7]
                    )
                ));
            }

            var theadCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'calendar-thead', true), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-' + type + '-thead', type), _classNames));

            return _react2.default.createElement(
                'thead',
                { className: theadCls, ref: 'calendar-thead' },
                _react2.default.createElement(
                    'tr',
                    null,
                    elements
                )
            );
        }
    }]);
    return CalendarHead;
}(_react.Component);

(0, _calendarMixin2.default)(CalendarHead);

exports.default = CalendarHead;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/view/table/calendar-thead.js
// module id = 625
// module chunks = 0